<template>
  <picture>
    <source
      v-if="isMobile && densities && densities.length > 0"
      :srcset="generateSrcSet(sourceFormat, true)"
      :type="`image/${sourceFormat}`"
      media="(max-width: 767px)"
    />
    <source
      v-if="densities && densities.length > 0"
      :srcset="generateSrcSet(sourceFormat)"
      :type="`image/${sourceFormat}`"
    />
    <img
      :src="useDynamicImage(`${basePath}/${getFileName()}.${imgFormat}`)"
      :alt="alt"
      :class="imageClass"
      loading="lazy"
    />
  </picture>
</template>

<script setup>
import {useDynamicImage} from '~/composables/useDynamicImage'

const {locale} = useI18n()

const props = defineProps({
  /** 이미지 기본 경로 */
  basePath: {
    type: String,
    required: true
  },
  /** 파일 이름(확장자 제외) */
  fileName: {
    type: String,
    required: true
  },
  /** 기본 이미지 확장자 */
  imgFormat: {
    type: String,
    default: 'png'
  },
  /** 반응형 이미지 확장자(webp, avif 등) */
  sourceFormat: {
    type: String,
    default: 'webp'
  },
  /** 이미지 대체 텍스트 */
  alt: {
    type: String,
    default: 'image'
  },
  /** 지원할 픽셀 밀도 배열 ['1x', '1_5x', '2x', '3x'] */
  densities: {
    type: Array,
    default: () => ['1x', '1_5x', '2x', '3x']
  },
  /** 이미지에 적용할 CSS 클래스 */
  imageClass: {
    type: String,
    default: ''
  },
  /** 모바일 이미지 버전 이미지가 별도로 있는지 여부 */
  isMobile: {
    type: Boolean,
    default: false
  },
  /** 현재 언어에 맞는 이미지 버전이 있는지 여부 */
  localized: {
    type: Boolean,
    default: false
  }
})

const getFileName = (isMobileVersion = false) => {
  let fileName = props.fileName

  if (props.localized && locale.value === 'en') {
    fileName = `${fileName}_en`
  }

  if (isMobileVersion) {
    fileName = `${fileName}_md`
  }

  return fileName
}

const generateSrcSet = (format, isMobileVersion = false) => {
  return props.densities
    .map(density => {
      const densitySuffix = typeof density === 'number' ? `${density}x` : density
      const fileName = getFileName(isMobileVersion)
      const path = `${props.basePath}/${fileName}@${densitySuffix}.${format}`
      const descriptor = typeof density === 'number' ? density : densitySuffix.replace('_', '.').replace('x', '')
      return `${useDynamicImage(path)} ${descriptor}x`
    })
    .join(',\n')
}
</script>
